export default {
  all: state => {
    return state.all
  },
  single: state => {
    return state.single
  },
  productTitleListImportData: state => {
    return state.productTitleListImportData
  },
  productTitleListManualData: state => {
    return state.productTitleListManualData
  }
}
